import { render, staticRenderFns } from "./AdminInvoices.vue?vue&type=template&id=ed72176e"
import script from "./AdminInvoices.vue?vue&type=script&lang=js"
export * from "./AdminInvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports